import React, { useState, useEffect } from 'react';
import { useProgressChecklist } from './ProgressChecklistContext';
import { ProgressChecklistFloatingIcon } from './ProgressChecklistFloatingIcon';
import { ProgressChecklistModal } from './ProgressChecklistModal';
import { View } from '../common/View';

export function ProgressChecklist() {
  const { state, openModal, closeModal } = useProgressChecklist();

  const handleOpenChecklist = () => {
    openModal();
  };

  const handleCloseModal = () => {
    closeModal();
  };

  // Close modal when checklist is hidden (but not when completed)
  useEffect(() => {
    if (!state.showChecklist) {
      closeModal();
    }
  }, [state.showChecklist, closeModal]);

  // Don't render anything if checklist is hidden (but keep it visible when completed)
  if (!state.showChecklist) {
    return null;
  }

  return (
    <>
      <ProgressChecklistFloatingIcon onOpenChecklist={handleOpenChecklist} />
      <ProgressChecklistModal isOpen={state.isModalOpen} onClose={handleCloseModal} />
    </>
  );
}
